import React, { useState, useEffect } from 'react';
import { useCompanyStore } from '../../stores/useCompanyStore';

interface CompanyStoreSlice {
  lastCompanyChange: number | null;
  activeCompany: { id: number; name: string } | null;
}

const GlobalUpdateIndicator: React.FC = () => {
  const { lastCompanyChange, activeCompany } =
    useCompanyStore() as unknown as CompanyStoreSlice;
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    // Solo mostrar si hay una empresa activa y un cambio reciente
    if (!activeCompany || !lastCompanyChange) {
      setIsVisible(false);
      return;
    }

    // Mostrar el indicador inmediatamente cuando hay un cambio
    setIsVisible(true);

    // Ocultar el indicador después de 3 segundos
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);

    // Cleanup del timer
    return () => {
      clearTimeout(timer);
    };
  }, [activeCompany, lastCompanyChange]);

  // No renderizar si no está visible
  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 animate-pulse">
        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        <span className="text-sm font-medium">
          Actualizando datos para: {activeCompany?.name}
        </span>
      </div>
    </div>
  );
};

export default GlobalUpdateIndicator;
